import { useState } from 'react';

// @mui
import { alpha } from '@mui/material/styles';
import { Typography, ListItemText, ListItemAvatar, MenuItem } from '@mui/material';
import {
    useGetAllStaffWebsiteAccounts,
} from 'services/management/staff-management/staffManagementServices';
// auth
import { useAuthContext } from '../../../auth/useAuthContext';
// components
import { CustomAvatar } from '../../../components/custom-avatar';
import Iconify from '../../../components/iconify';
import Scrollbar from '../../../components/scrollbar';
import MenuPopover from '../../../components/menu-popover'; 
import { IconButtonAnimate } from '../../../components/animate';

// ----------------------------------------------------------------------

const ITEM_HEIGHT = 64;

export default function WebAccountPopover() {
    const { user, switchAccount } = useAuthContext();
    const [openPopover, setOpenPopover] = useState(null);
    const {
        data: websiteData,
        isLoading: modulesDataIsLoading,
        isError: modulesDataIsError,
    } = useGetAllStaffWebsiteAccounts();
    const handleOpenPopover = (event) => {
        setOpenPopover(event.currentTarget);
    };

    const handleClosePopover = () => {
        setOpenPopover(null);
    };
    if (modulesDataIsLoading) return true;
    if (modulesDataIsError) return true;
    const accounts = websiteData?.websites;
    const handleSelectAccount = async (accid) => {
        try {
            // WB-PP-01/02: cookie carries auth; do not read JWT from sessionStorage
            await switchAccount(accid);
        } catch (error) {
            console.error(error);
        }
    }
    const webAcc = accounts
        ?.filter((account) => account?._id !== user?.websiteProjectId);
    return (
        <>
            {webAcc && webAcc?.length > 0 ?
                <IconButtonAnimate
                    color={openPopover ? 'primary' : 'default'}
                    onClick={handleOpenPopover} title="Switch Account"
                    sx={{
                        width: 40,
                        height: 40,
                        ...(openPopover && {
                            bgcolor: (theme) =>
                                alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
                        }),
                    }}
                >
                    <Iconify icon="eva:people-fill" title="Switch Account" />
                </IconButtonAnimate> : null}

            <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 320 }}>
                <Typography variant="h6" sx={{ p: 1.5 }}>
                    Switch Accounts
                    {/* <Typography component="span">({accounts.length})</Typography> */}
                </Typography>

                <Scrollbar sx={{ height: ITEM_HEIGHT * 2 }}>
                    {webAcc
                        ?.map((account) => {
                            const logo =
                                account?.basicDetails?.logo && account?.basicDetails?.logo !== ""
                                    ? `https://technolitics-s3-bucket.s3.ap-south-1.amazonaws.com/maira-s3-bucket/${account.basicDetails.logo}`
                                    : null;

                            return (
                                <MenuItem onClick={() => handleSelectAccount(account._id)} key={account._id} sx={{ height: ITEM_HEIGHT }}>
                                    <ListItemAvatar>
                                        <CustomAvatar
                                            src={logo}                               // <-- dynamic logo
                                            name={account?.basicDetails?.name}       // <-- used if logo = null
                                        />
                                    </ListItemAvatar>

                                    <ListItemText
                                        primary={account?.basicDetails?.name}
                                        primaryTypographyProps={{
                                            typography: 'subtitle2',
                                            sx: { mb: 0.25 },
                                        }}
                                        secondaryTypographyProps={{
                                            typography: 'caption',
                                        }}
                                    />
                                </MenuItem>
                            );
                        })}

                </Scrollbar>
            </MenuPopover>
        </>
    );
}
